<template>
  <div id="">
    <vxe-grid v-bind="addTableList" @cell-dblclick="dbClick">
      <template v-slot:toolbar>
        <vxe-toolbar custom>
          <template v-slot:buttons>
            <vxe-form>
              <vxe-form-item>
                <template v-slot>
                  <vxe-input v-model="searchVal" :placeholder="$t('message.placeholder.search')" @keyup.enter.native="searchClick"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <template v-slot>
                  <vxe-button status="primary" @click="searchClick">{{$t('message.button.search')}}</vxe-button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </template>
        </vxe-toolbar>
      </template>
    </vxe-grid>
  </div>
</template>

<style scoped>
	
</style>

<script>
export default {
  name: "searchAdd", //模板名称
  data() {
    return {
      searchVal:"",
      get_change_info: "",
      rols_text:[],
      tableShow:false,
      oldTableValue:[],
      rols_text:[],
      cols:[],
      addTableList: {
          keepSource: true,
          resizable: true,
          border: true,
          stripe: true,
          highlightHoverRow: true,
          highlightCurrentRow: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "530",
          size: "small",
          columns: [],
                
          data: [],
          treeConfig: {
            lazy: true,
            children: 'children',
            hasChild: 'hasChildren',
            loadMethod: this.loadChildrenMethod
          },
          editConfig: {
            trigger: 'dblclick',
            mode: 'row',
            showIcon: false,
            // activeMethod: this.activeRowMethod,
            showStatus: true,
          },
          sortConfig: {
            trigger: 'cell'
          },
        },
	}
  },
	mounted(){
	},
  methods: {
    dbClick(row) {
      //console.log(row);
      this.$emit('listDbClick', row.row);
    },
    async searchClick() {
      //console.log(this.searchVal);
      var val = this.searchVal;
      var vm = this;
      if(val == '') {
        vm.$message({
          showClose: true,
          message: this.$t('message.warning.searchErr_01'),
          type: 'warning'
        });
      }  else {
        const { //获取标题
          data: res
        } = await this.$http.get("/pmdm/admin/userGroup/getUserGroups?name="+ val);
        console.log(res);
        if(res.code == 200) {
          if(res.object.userGroups.length == 0) {
            vm.$message({
              showClose: true,
              message: this.$t('message.warning.searchErr_02'),
              type: 'warning'
            });
            this.addTableList.data = [];
          } else {
            var items = res.object.userGroups;
            console.log(items);
            var tableContent = [];
            for( var i = 0; i < items.length; i++) {
              var obj = {};
              obj.id = items[i].id;
              obj.classId = items[i].classId;
              obj.subclassId = items[i].subclassId;
              obj.name = items[i].name;
              obj.description = items[i].description;
              
              obj.createdTime = items[i].created;
              
              tableContent.push(obj);
            };
            this.addTableList.data = tableContent;
            this.addTableList.columns = [                
              { field: 'name', title: this.$t("message.table.userName") , sortable: true},
              { field: 'description', title: this.$t("message.table.des") , sortable: true},
              { field: 'createdTime', title: this.$t("message.table.createDate") , sortable: true}
            ];
          }
        };
      }
    },
  },
  created() {

  }
};
</script>